import styled from 'styled-components';
import { colors } from "colors";


export const ButtonWrapper = styled.button`
  padding: 12px 32px;
  border-radius: 4px;
  background-color: transparent;
  border: solid 1px ${colors.brightBlue};

  color: ${colors.brightBlue};
  font-size: 14px;
  font-weight: bold;
  min-width: 256px;
  
  svg {
    fill: ${colors.brightBlue};
  }

  :hover {
    box-shadow: 2px 2px 4px ${colors.silver};
    cursor: pointer;
  }
`;

export const PartWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  
  padding: 0 32px;
  color: ${colors.slateGrey};
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.paleGrey};
  font-size: 14px;

  div.container {
    flex: 1;
    padding: 10px 4px;
    min-width: 144px;
    
    @media only screen and (max-width: 768px) {
      width: 100%;

      display: flex;
      flex-flow: column wrap;
      flex-basis: auto;

      &:first-child {
        flex-flow: row wrap;
      }
      > :nth-child(1) {
        color: ${colors.steel};
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 4px;
      }
      > :nth-child(2) {
        flex: 1;
      }
    }
  }
  
  @media only screen and (min-width: 768px) {
      div.container:nth-child(1) {
        flex: 0.25;
        min-width: 32px;
        max-width: 32px;
        font-weight: 600;
      }
      div.container:nth-child(4) {
        flex: 0.5;
        input {
          text-align: end;
        }
      }
      div.container:nth-child(5) {
        flex: 2;
      }
      div.container:nth-child(6) {
        flex: 0.75;
        text-align: end;
      }
    }
    
    div.container:nth-child(7) {
      flex: 0.25;
      display: flex;
      justify-content: flex-end;
      
      @media only screen and (max-width: 768px) {
        flex-flow: row wrap;
        flex: 1;
        > * {
          flex: none;
        }
      }
      svg {
        cursor: pointer;
        padding: 8px;
        width: 16px;
        height: 16px;
      }
      svg:first-child {
        stroke: ${colors.steel};
      }
      svg:first-child:hover {
        stroke: ${colors.strawberry};
      }
      svg:last-child {
        fill: ${colors.paleGrey};
      }
      svg:last-child:hover {
        fill: ${colors.steel};
        cursor: grab;
      }
      svg:last-child:hover:active {
        fill: ${colors.steel};
        cursor: grabbing;
      }
    }
  }
`;
